var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33333 5.50586C5.8731 5.50586 5.5 5.87896 5.5 6.33919V13.0059C5.5 13.4661 5.8731 13.8392 6.33333 13.8392H13C13.4602 13.8392 13.8333 13.4661 13.8333 13.0059V6.33919C13.8333 5.87896 13.4602 5.50586 13 5.50586H6.33333ZM3.83333 6.33919C3.83333 4.95848 4.95262 3.83919 6.33333 3.83919H13C14.3807 3.83919 15.5 4.95848 15.5 6.33919V13.0059C15.5 14.3866 14.3807 15.5059 13 15.5059H6.33333C4.95262 15.5059 3.83333 14.3866 3.83333 13.0059V6.33919Z",
    fill: "#818181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.23223 1.23809C1.70107 0.769251 2.33696 0.505859 3 0.505859H9.66667C10.3297 0.505859 10.9656 0.769251 11.4344 1.23809C11.9033 1.70693 12.1667 2.34282 12.1667 3.00586V4.67253C12.1667 5.13276 11.7936 5.50586 11.3333 5.50586C10.8731 5.50586 10.5 5.13276 10.5 4.67253V3.00586C10.5 2.78485 10.4122 2.57288 10.2559 2.4166C10.0996 2.26032 9.88768 2.17253 9.66667 2.17253H3C2.77899 2.17253 2.56702 2.26032 2.41074 2.4166C2.25446 2.57288 2.16667 2.78485 2.16667 3.00586V9.67253C2.16667 9.89354 2.25446 10.1055 2.41074 10.2618C2.56702 10.4181 2.77899 10.5059 3 10.5059H4.66667C5.1269 10.5059 5.5 10.879 5.5 11.3392C5.5 11.7994 5.1269 12.1725 4.66667 12.1725H3C2.33696 12.1725 1.70107 11.9091 1.23223 11.4403C0.763392 10.9715 0.5 10.3356 0.5 9.67253V3.00586C0.5 2.34282 0.763392 1.70693 1.23223 1.23809Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy2);
export default __webpack_public_path__ + "static/media/copy_2.bc22a124044693d6d65c8048adf1807b.svg";
export { ForwardRef as ReactComponent };